import { Outlet } from 'react-router-dom';
import { Navbar } from '@/components/public/Navbar';
import { Footer } from '@/components/public/Footer';
import { CookieBanner } from '@/components/public/CookieBanner';
import { MobileBottomNavbar } from './MobileBottomNavbar';

export function PublicLayout() {
  return (
    <>
      <Navbar />
      <MobileBottomNavbar />
      <main className="flex-1 bg-white min-h-screen flex flex-col pb-[72px] md:pb-0">
        <Outlet />
      </main>
      <Footer />
      <CookieBanner />
    </>
  );
}
